module.exports = __webpack_public_path__ + "static/img/bg@2x.9592a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg@2x.png
// module id = /719
// module chunks = 1